<template>
  <StSelect
    v-model="selected"
    class="select-filter"
    :placeholder="t('casino.sort')"
    :items="sortList"
    size="s"
    icon-prefix="filter-solid"
    data-t="select-sort"
  />
</template>

<script setup lang="ts">
import { useSelectSorting } from './useSelectSorting'

const { t } = useI18n()

const props = defineProps<{
  modelValue: string
  categoryCode?: string
  provider?: string
}>()

const emit = defineEmits<{
  'update:model-value': [value: string | number]
}>()

const selected = computed({
  get() {
    return props.modelValue
  },
  set(value: string | number) {
    emit('update:model-value', value)
  },
})
const { sortList } = useSelectSorting()
</script>

<style scoped>
.select-filter {
  min-width: 160px;
}
</style>
